import React from 'react'
import * as SelectRadix from "@radix-ui/react-select";
import * as ScrollAreaRadix from "@radix-ui/react-scroll-area";
import styles from "./select.module.css"
import { Arrow } from "./arrow";
import { Loader } from "./loader"
export function Select({ setValue, items, placeholder, disabled, value, isLoading }) {







    return (
        <SelectRadix.Root key={value} disabled={disabled} value={value} onValueChange={(e) => (setValue(e))}   >
            <SelectRadix.Trigger className={styles.trigger}   >
                <SelectRadix.Value defaultValue={value} placeholder={placeholder} />
                {isLoading && <Loader />}
                <SelectRadix.Icon >
                    <Arrow className={styles.icon} />
                </SelectRadix.Icon>
            </SelectRadix.Trigger>
            <SelectRadix.Portal >
                <SelectRadix.Content position="popper" className={styles.content}>

                    <ScrollAreaRadix.Root className={styles.scrollAreaRoot} type="auto">
                        <SelectRadix.Viewport asChild className={styles.viewport}>
                            <ScrollAreaRadix.Viewport className={styles.scrollAreaViewport} style={{ overflowY: `auto` }}>
                                {
                                    items.map((item) => {
                                        //! Обработать value={item?.value?.toString()} если null и вывести "нет данных" в SelectRadix.ItemText
                                        return <SelectRadix.Item key={item.id} value={item?.value?.toString()} className={styles.item}>
                                            <SelectRadix.ItemText>{item.text}</SelectRadix.ItemText>
                                        </SelectRadix.Item>
                                    })}
                            </ScrollAreaRadix.Viewport>
                        </SelectRadix.Viewport>
                        <ScrollAreaRadix.Scrollbar
                            className={styles.scrollAreaScrollbar}
                            orientation="vertical"
                        >
                            <ScrollAreaRadix.Thumb className={styles.scrollAreaThumb} />
                        </ScrollAreaRadix.Scrollbar>
                    </ScrollAreaRadix.Root>

                </SelectRadix.Content>
            </SelectRadix.Portal>
        </SelectRadix.Root>
    )
}
